import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { IAppConfigRootModel } from "../../models/app-config-root.model";
import { AppConfigUtil } from "../../utils/app-config.util";

import { AppUtil } from "../../utils/app.util";

@Injectable({
	providedIn: "root"
})
export class AppConfigService {
	constructor(private http: HttpClient) {}

	private static alreadyLoadedModuleConfig: Set<string> = new Set();

	private fetchApplicationConfig(
		_propertyResourceUrl: string,
		_propertyResourceUri: string
	): Observable<Object> {
		return this.http.get(_propertyResourceUrl + _propertyResourceUri);
	}

	public load(
		_propertyResourceUrl: string,
		_propertyResourceUri: string
	): Promise<boolean> {
		return new Promise<boolean>((resolve, reject) => {
			if (
				_propertyResourceUri &&
				!AppConfigService.alreadyLoadedModuleConfig.has(_propertyResourceUri)
			) {
				this.fetchApplicationConfig(
					_propertyResourceUrl,
					_propertyResourceUri
				).subscribe(
					(appConfigResponse: IAppConfigRootModel) => {
						if (appConfigResponse) {
							const appConfigResponsePrev = AppConfigUtil.getProperties();
							const appConfigResponseMerged = <IAppConfigRootModel>AppUtil.mergeSourceObjects(
								appConfigResponsePrev,
								appConfigResponse
							);
							AppConfigUtil.setProperties(appConfigResponseMerged);
							AppConfigService.alreadyLoadedModuleConfig.add(
								_propertyResourceUri
							);
						}

						AppUtil.log(
							"AppConfigService : load() : App Config loaded :: AppConfigUtil.getProperties() :: ===> %o ",
							AppConfigUtil.getProperties()
						);
						return resolve(true);
					},
					(error: Response) => {
						AppUtil.error(
							"**************AppConfigService : load() : App Config not loaded. %o not found **************",
							_propertyResourceUrl + _propertyResourceUri
						);
						return resolve(true);
					}
				);
			} else {
				return resolve(true);
			}
		});
	}
}
